module.exports = __webpack_public_path__ + "static/img/11.836eb13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/11.png
// module id = DipO
// module chunks = 2